import Phaser from "phaser";
import { data } from "../data";
/** @param {Phaser.Scene} scene */
export const adjustSound = (scene, width, height, volume = 0.2) => {
  const scaleX = data().scaleX;
  const startingPosition = volume * 300 * scaleX;
  scene.sound.volume = Math.pow(volume, 2);
  const speaker = scene.add
    .image(width, height, "speaker")
    .setScale(0.05 * scaleX);
  const yellowRec = scene.add
    .rectangle(320 * scaleX, height, startingPosition, 15 * scaleX, 0xdda616)
    .setOrigin(0, 0.5);
  const blackRec = scene.add
    .rectangle(
      320 * scaleX + startingPosition,
      height,
      300 * scaleX - startingPosition,
      15 * scaleX,
      0x0000
    )
    .setOrigin(0, 0.5);
  /*
        lowest point is 320
        highest point is 320 + 300
        */
  const circle = scene.add
    .image(320 * scaleX + startingPosition, height, "circle")
    .setScale(0.065 * scaleX)
    .setInteractive({ draggable: true })
    .on("drag", (pointer, dragX, dragY) => {
      circle.fillTint = 0xb0adad;
      let theDrag = dragX - 320 * scaleX;
      let theDragPercentage = theDrag / 300;
      let soundPercentage = theDrag / (300 * scaleX);
      if (theDrag <= 0) {
        circle.x = 320 * scaleX;
        scene.sound.volume = 0;
      } else if (theDrag > 300 * scaleX) {
        circle.x = (320 + 300) * scaleX;
        scene.sound.volume = 1;
      } else {
        circle.x = dragX;
        scene.sound.volume = Math.pow(soundPercentage, 2);
        // divided by the scaleX to eliminate scaleX effect on the sound.
        yellowRec.width = 300 * theDragPercentage;
        blackRec.x = dragX;
        blackRec.width = 300 * scaleX - 300 * theDragPercentage;
      }
    })
    .on("pointerdown", () => {
      circle.setTint(0xb0adad);
    })
    .on("pointerup", () => {
      circle.setTint(0xffffff);
    })
    .on("pointerout", () => {
      circle.setTint(0xffffff);
    });
  const soundAssets = scene.add.group([speaker, yellowRec, blackRec, circle]);
  return { soundAssets };
};
